import axios from "../utils/axios";

// 🏢 Get Product Category
export const getProductCategory = async (req) => {
  const response = await axios.get("/api/ProductCategory/GetAll");
  // console.log("product category",response);
  return response.data;
};

// 🏢 Get Product Category by userId
export const getProductCategoryByUser = async (req) => {
  const response = await axios.get("/api/ProductCategory/GetByUser?userId="+req);
  return response.data;
};

// 🏢 Get Product Category by shop
export const getProductCategoryByShop = async (req) => {
  const response = await axios.get("/api/ProductCategory/GetByShop?shopId="+req);
  return response.data;
};

export const getProductCategoryByStore = async (userId) => {
  const response = await axios.get("/api/ProductCategory/GetByUser", {
    params: { userId },
  });
  return response.data;
};

// 🏢 Get Product List
export const getProductList = async (req) => {
  const response = await axios.get("/api/Product/GetListProductIndex", {
    params: req,
  });
  //console.log(response);
  return response.data;
};

export const getProductBySlug = async (slug) => {
  const response = await axios.get("/api/Product/GetProductBySlug", {
    params: { slug },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get Product List
export const getRecommendedProductList = async (req) => {
  const response = await axios.post(
    "/api/Product/GetProductRecommendationWithFilter",
    {
      skip: req.skip || 0,
      take: req.take || 10,
      filter: req.filter || "",
      startDate: req.startDate || null,
      endDate: req.endDate || null,
      quickFilter: req.quickFilter || [],
      sort: req.sort || null,
    },
    {
      params: {
        productId: req.productId,
      },
    }
  );
  //console.log(response);
  return response.data;
};

// 🏢 Get Product Variant
export const getProductVariant = async (productId) => {
  const response = await axios.get("/api/Variant/GetVariantCombinationByProduct", {
    params: {
      productId: productId,
    },
  });
  //console.log(response);
  return response.data;
};

export const viewProduct = async(productId) =>{
  const response = await axios.get("/api/Product/ViewProduct", {
    params: {
      id: productId,
    },
  });
  //console.log(response);
  return response.data;
}
